

export default  ()=> {

    var callbacks = {};


    const uuid = ()=> {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    
     const getEncodexIos = async(text) => {
        let attach = uuid();
        return await new Promise(async (reslove, reject) => {
            // //超时时间
            let timer = setTimeout(() => {
                reject(new Error('getEncodexIos 超时'));

            }, 3000);
            //设置等待返回结果        
            callbacks[attach] = async (rs) => {

                clearTimeout(timer);
                reslove(rs);
            }
            window.receiveEncodexResult = function(rs, reqId) {

                if (reqId && callbacks[reqId]) {
                    let callback = callbacks[reqId];
                    delete callbacks[reqId];
                    callback?.(rs)
                }
        
            };
            //发送消息 
            window?.gameBridge?.getEncodex?.({ text, attach });
            
        })
    }

    const getEncodeIos  = async(text) => {

        let attach = uuid();
        return await new Promise(async (reslove, reject) => {
            //超时时间
            let timer = setTimeout(() => {
                reject(new Error('getEncodeIos 超时'));

            }, 3000);
            //设置等待返回结果                

            callbacks[attach] = async (rs) => {

                clearTimeout(timer);
                reslove(rs);
            }
            window.receiveEncodeResult = function(rs, reqId) {

                if (reqId && callbacks[reqId]) {
                    let callback = callbacks[reqId];
                    delete callbacks[reqId];
                    callback?.(rs)
                }
        
            };

            //发送消息
            window?.gameBridge?.getEncode?.({ text, attach });
        })
    }

    const getDecodeIos = async(text) => {
        let attach = uuid();
        return await new Promise(async (reslove, reject) => {
            //超时时间
            let timer = setTimeout(() => {
                reject(new Error('getDecodeIos 超时'));

            }, 3000);
            //设置等待返回结果                

            callbacks[attach] = async (rs) => {

                clearTimeout(timer);
                reslove(rs);
            }
            window.receiveDecodeResult = function(rs, reqId) {

                if (reqId && callbacks[reqId]) {
                    let callback = callbacks[reqId];
                    delete callbacks[reqId];
                    callback?.(rs)
                }
            };

            //发送消息
            window?.gameBridge?.getDecode?.({ text, attach });
        })
    }

    return  {getEncodexIos,getEncodeIos,getDecodeIos}
}